import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

import type { InvestmentType } from '@/integrations/supabase/investment.models';

export type { InvestmentType };

/**
 * Hook to fetch investment types
 * 
 * @returns Query result containing investment types sorted by is_default DESC, name ASC
 * 
 * @example
 * const { data: types, isLoading } = useInvestmentTypes();
 */
export function useInvestmentTypes() {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['investment-types', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('investment_types' as any)
        .select('*')
        .or(`is_default.eq.true,user_id.eq.${user!.id}`)
        .order('is_default', { ascending: false })
        .order('name', { ascending: true });
      
      if (error) throw error;
      return data as InvestmentType[];
    },
    enabled: !!user,
  });
}
